import * as React from 'react';
import { Route, Switch } from 'react-router';
import { Layout } from './components/Layout';
import './custom.css'
import "bootstrap-icons/font/bootstrap-icons.css";
import { Boards } from './components/Boards';
import { Board } from './components/Board';
import { Page } from './components/Page';
import { processEmbedToken, getUser, setAuthExpiredCallback } from './api/api';

const qs = new URLSearchParams(window.location.search);
const embedToken = qs.get("embedToken");
let isEmbedded = embedToken != null;

class AuthRoute extends Route<{ isAuthenticated: boolean; isLoading: boolean; }> {
    render() {
        if (this.props.isLoading) {
            return "Loading...";
        }
        if (!this.props.isAuthenticated) {
            let url = "/Account/Login?returnUrl=" + encodeURIComponent(window.location.href);
            if (isEmbedded) {
                url += "&embedded=true";
            }
            window.location.href = url;
            return "Loading...";
        }
        return super.render();
    }
}

export default class App extends React.Component<{}, { isAuthenticated: boolean; isLoading: boolean; authExpired: boolean; }> {
    static displayName = App.name;

    state = {
        isAuthenticated: false,
        isLoading: true,
        authExpired: false,
    };

    async componentDidMount() {
        setAuthExpiredCallback(() => {
            this.setState({ isAuthenticated: false, authExpired: true });
            if (!isEmbedded) {
                window.location.reload();
            }
        });
        if (embedToken != null) {
            await processEmbedToken(embedToken);
        }
        const user = await getUser();
        this.setState({ isAuthenticated: user.userId != null, isLoading: false });
    }

    render() {
        return this.state.isLoading ? null :
            this.state.authExpired ? this.renderSessionExpired() :
                <Layout hideNavbar={isEmbedded} isAuthenticated={this.state.isAuthenticated}>
                    <Switch>
                        <AuthRoute {...this.state} exact path='/' component={Boards} />
                        <AuthRoute {...this.state} exact path='/boards/:id' component={Board} />
                        <AuthRoute {...this.state} exact path='/boards/:boardId/pages/:id' component={Page} />
                        <Route path='*' render={() => "Page not found."} />
                    </Switch>
                </Layout>;
    }

    renderSessionExpired() {
        return "Session expired." + (isEmbedded ? " Reload page to sign in again." : "");
    }
}
